import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EventModel, EventType } from '../interfaces/event.model';

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {
  // public _events = new BehaviorSubject<Events>({name: '', data: {}});
  _events = new Subject<EventModel>();

  fire(data: EventModel): any {
    this._events.next(data);
  }

  get events(): any {
    return this._events;
  }

  on(type: string, typeName: string, callback: any): any {
    const subscription: any = this.events.pipe(
      filter((value: EventModel) => {
        let itmToCompare = value.name;
        if (type === 'type') {
          itmToCompare = value.type;
        }
        return itmToCompare === typeName;
      })
    ).subscribe(callback);

    return (): void => {
      subscription.remove(subscription);
      subscription.unsubscribe();
    };
  }

  /**
 * On Event broadcast, send the subscription.
 * Use this for safe subscriptions that needs to destroy on component destruction. (avoid hanged subscriptions)
 * @param type: string
 * @param typeName: string
 */
  onEvent(type: string, typeName: string): Observable<any> {
    const subscription: any = this.events.pipe(
      filter((value: any) => {
        let itmToCompare = value.name;
        if (type === 'type') {
          itmToCompare = value.type;
        }
        return itmToCompare === typeName;
      })
    );

    return subscription;
  }

  reloadDataTable(id?: string): void {
    this.fire({
      name: 'datatable-reload',
      type: EventType.DATATABLE,
      data: { id }
    });
  }
}
